// extracted by mini-css-extract-plugin
module.exports = {"container":"Auth_container__m0d9A","mainContent":"Auth_mainContent__34_ok"};